import SkeletonLoader from './SkeletonLoader.component';

export default SkeletonLoader;
